
























import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'

@Component({
  props: {
    sentMailResult: {
      type: Object,
      required: false
    }
  },
  components: {
    Modal
  }
})
export default class StatementsMailCompleteModal extends Vue {

}
